import contentDisposition from 'content-disposition'

export async function blobToDataURL(blob) {
    let dataURL;

    await (() => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob)
            reader.onloadend = () => {
                window.location.assign(reader.result);
                // URL.revokeObjectURL(exportUrl)
                URL.revokeObjectURL(reader.result)
                resolve(dataURL = reader.result)
            }
        })
    })()

    return dataURL
}

export function addDynamicEventListener(event, parent, selector, handler) {

    document.querySelector(parent).addEventListener(event, function(e) {
        let target = e.target;
        e.preventDefault();
        while (target && target !== this) {
            if (target.matches(selector)) {
                handler.call(this, target);
                break;
            }
            target = target.parentNode;
        }
    })
}

export function streamFile(response) {
    if (!response.headers || !response.data || response.headers['content-disposition'] === undefined) {
        return;
    }

    const blob = response.data;
    const a = document.createElement('a');
    const filename = contentDisposition.parse(response.headers['content-disposition']).parameters.filename;

    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
    } else {
        a.href = (window.URL || window.webkitURL).createObjectURL(blob);
        a.download = filename;
        const ev = document.createEvent('MouseEvents');
        ev.initMouseEvent(
            "click", true, false, window, 0, 0, 0, 0, 0
            , false, false, false, false, 0, null
        );
        a.dispatchEvent(ev);
        setTimeout(() => {
            (window.URL || window.webkitURL).revokeObjectURL(a.href);
        }, 1000);
    }
}

/**
 * Removes double slashes from url
 * @param url
 */
export function sanitizeUrl(url) {
    return url.replace(/([^:])\/+/g, '$1/');
}